import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IApplicationState } from "redux/root-reducer";
import { ReactComponent as ApartmentIcon } from "../../common/images/ApartmentIcon.svg";
import { actionCreator } from "../../nodeDetails/nodeDetails.reducer";
import styles from "./Search.module.scss";
import SearchNode from "./SearchNode";
import { INode } from "../types";

const Search: React.FC = () => {
  const [node] = React.useState<INode>();
  const domain = useSelector(
    (state: IApplicationState) => state.common.selectedDomain
  );
  const dispatch = useDispatch();
  const history = useHistory();
  dispatch(actionCreator.clearCurrentRelativeHumidityAndTemperature);

  const onSelectedSearchCase = (node: INode | string | null) => {
    if (typeof node === "object") {
      if (!node || node === undefined || typeof node === "string" || !domain)
        return;
      dispatch(actionCreator.setSelectedNode(node));
      history.push(`/${domain.Code}/safetySensors/${node.ID}`);
    }
  };
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.searchTextContainer}>
        <ApartmentIcon className={styles.apartmentLogo}></ApartmentIcon>
        <h1>{t("Search apartment")}</h1>
      </div>
      <SearchNode onChange={onSelectedSearchCase} node={node} />

      <div className={styles.buttonContainer}></div>
    </div>
  );
};

export default Search;
